export const apiField = 'flat_roof_snow_load';

const config = (max: number = 100) => ({
  label: 'flatRoofSnowLoad',
  type: 'Number',
  apiField,
  missing: undefined,
  min: 0,
  max,
  step: 0.1,
});

export default config;
